import { FC } from "react";
import { Typography } from "@jobber/components/Typography";
import styles from "./AppLogo.module.scss";

type AppLogo = {
  logo: string;
};

const Logo: FC<AppLogo> = ({ logo }) => {
  return (
      <div className={styles.logo}>
          <img src={logo} alt="app logo"/>
          <Typography textColor={"white"} size={"jumbo"} fontWeight={"black"}>Xero Integration</Typography>
      </div>
  );
};

export default Logo;
